<template>
  <div class="vote-page">
    <div class="top-bar">
      <div class="title">
        <span>{{ voteInfo.projectName }}</span>
        <span>{{ voteInfo.voteName }}</span>
      </div>
      <div class="btn-group">
        <a-popconfirm title="确定删除吗?" @confirm="deleteVoteRecord" okText="确定" cancelText="取消">
          <a-button v-if="voteRecordId" class="btn-item" size="small" type="danger">删除</a-button>
        </a-popconfirm>
      </div>
    </div>
    <div class="common-info">
      <div class="info-item">
        <div class="item-label">项目轮次:</div>
        <div class="item-content">{{ voteInfo.round }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">投资决策节点:</div>
        <div class="item-content">{{ voteInfo.decisionPoint }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">发起日期:</div>
        <div class="item-content">{{ voteInfo.voteTime }}</div>
      </div>
      <div class="info-item" style="align-items: flex-start">
        <div class="item-label">Vote说明:</div>
        <div class="item-content">{{ voteInfo.voteIllustrate }}</div>
      </div>
    </div>
    <div class="vote-content">
      <div class="info-item ant-form-item-required">
        <div class="item-label">填写人:</div>
        <div class="item-content">
          <span style="margin-right: 20px">{{ userInfo.nickname }}</span>
          <span v-if="[1, 2].includes(substituteData.status)">
            <span style="color:#bbb; margin-right: 20px;">代替</span>
            <span v-if="2 == substituteData.status" style="margin-right: 20px;">{{ substituteData.user }}</span>
            <a-select v-if="1 == substituteData.status" style="width: 100px; margin-right: 20px;" @change="selectSubstituteUser" placeholder="被替代人">
              <a-select-option v-for="user in substituteData.user" :key="user.id">{{ user.nickname }}</a-select-option>
            </a-select>
          </span>
          填写
        </div>
      </div>
      <div class="info-item ant-form-item-required">
        <div class="item-label">Vote:</div>
        <a-radio-group name="radioGroup" v-model="voteContent">
          <a-radio :value="5">
            <span style="color: rgb(65,148,136)">正面</span>
          </a-radio>
          <a-radio :value="4">
            <span style="color: rgb(151,193,92)">偏正面</span>
          </a-radio>
          <a-radio :value="3">弃权</a-radio>
          <a-radio :value="2">
            <span style="color: rgb(242,156,56)">偏负面</span>
          </a-radio>
          <a-radio :value="1">
            <span style="color: rgb(211,51,48)">负面</span>
          </a-radio>
        </a-radio-group>
      </div>
      <div class="info-item info-item-textarea">
        <div class="item-label">投票理由:</div>
        <a-textarea
          class="item-content"
          :autoSize="{ minRows: 3 }"
          placeholder="请填写投票理由，重点说明为什么做出上述意见的投票"
          v-model="voteReason"
        ></a-textarea>
      </div>
      <div class="info-item info-item-textarea">
        <div class="item-label">补充观点:</div>
        <a-textarea
          class="item-content"
          :autoSize="{ minRows: 3 }"
          placeholder="针对该项目或赛道，有什么其他补充观点/建议等"
          v-model="additionalPoint"
        ></a-textarea>
      </div>
      <a-button class="vote-btn" @click="vote">Vote</a-button>
    </div>
  </div>
</template>

<script>
import { voteDetail, vote, deleteVoteRecord } from '@/api/projectVote';

export default {
  computed: {
    substituteData: function() {
      let status, user;
      const userInfo = this.$store.state.user.userInfo;
      /**自填模式 */
      if (+this.voteInfo.voteMode === 2) {
        status = 3;
        user = this.voteInfo.voteList.filter(item => +item.userId === +userInfo.id)[0]['userName'];
        return {
          status,
          user
        };
      }
      /**
       * 代填模式
       * 1、本人是管理员（userInfo.id==voteInfo.voteAdministratorId），
       * 且从参与vote（!itemUserId）进入：xx代替xx，且有可选框
       * 2、本人是管理员（userInfo.id==voteInfo.voteAdministratorId），
       * 且从编辑进入非本人条目（userInfo.id!=itemUserId）：xx代替xx填写，且没有可选框
       * 3、从编辑按钮进入本人页面（userInfo.id==itemUserId）或
       * 从参与vote进入本人页（!itemUserId && voteInfo.voteList.map(item=>item.userId).includes(userInfo.id)）：xx填写
       */
      if (+userInfo.id === +this.voteInfo.voteAdministratorId && !this.itemUserId) {
        /**xx代替xx，有选择框 填写*/
        status = 1;
        user = this.voteInfo.voteList
          .filter(item => !item.voteStatus)
          .map(item => {
            return { id: item.userId, nickname: item.userName };
          });
      } else if (+userInfo.id === +this.voteInfo.voteAdministratorId && +userInfo.id !== +this.itemUserId) {
        /**xx代替xx填写，没有选择框 */
        status = 2;
        const substituteUser = this.voteInfo.voteList.filter(item => +item.userId === +this.itemUserId)[0];
        user = substituteUser['userName'];
        this.substituteId = substituteUser['userId']; // eslint-disable-line
      } else if (!this.itemUserId && this.voteInfo.voteList.map(item => item.userId).includes(userInfo.id)) {
        /**xx填写 */
        status = 3;
        user = this.voteInfo.voteList.filter(item => +item.userId === +userInfo.id)[0]['userName'];
      }
      return {
        user,
        status
      };
    }
  },
  data() {
    return {
      voteId: null,
      userInfo: this.$store.state.user.userInfo,

      itemUserId: null, //null的话说明从参与vote进入，否则从编辑进入
      substituteId: null,
      voteContent: null, //1~5
      voteReason: '',
      additionalPoint: '',
      voteRecordId: null,
      voteInfo: {
        voteStatus: 2,
        voteAdministratorId: null,
        round: null,
        voteName: null,
        projectName: null,
        decisionPoint: null,
        voteTime: null,
        voteIllustrate: null,
        voted: 0,
        voteMode: null, //1 代填 2 自填
        totalVotes: 0,
        comprehensiveScore: 0, //无打分为null
        /**
        {
          voteRecordId: 1,
          userId: "",
          userName: "",
          voteStatus: true, //是否已经投过票
          voteMode: 1, //1 代填 2 自填
          voteContent: "正面",
          voteReason: "市场规模足够，技术优势明显",
          additionalPoint: "该赛道更适合天使轮",
          voteTime: "2019-11-28 18:00"
        }
         */
        voteList: []
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.voteId = this.$route.query.voteId;
      this.voteRecordId = this.$route.query.voteRecordId;
      this.itemUserId = this.$route.query.itemUserId;
      voteDetail({
        voteId: this.voteId
      }).then(res => {
        if (res.code === 200) {
          const data = res.data;
          Object.assign(this.voteInfo, data);
          if (this.itemUserId) {
            const thisVoteItem = data.voteList.filter(item => +item.userId === +this.itemUserId)[0];
            this.voteReason = thisVoteItem.voteReason;
            this.additionalPoint = thisVoteItem.additionalPoint;
            this.voteContent = parseInt(thisVoteItem.voteContent, 10);
          }
        }
      });
    },
    selectSubstituteUser(substituteId) {
      this.substituteId = substituteId;
    },
    deleteVoteRecord() {
      deleteVoteRecord({
        voteRecordId: this.voteRecordId
      }).then(res => {
        if (res.code === 200) {
          this.$router.replace({
            path: `/project/voteRecords`,
            query: {
              voteId: this.voteId,
              projectId: this.$route.query.projectId
            }
          });
        }
      });
    },
    validate() {
      // 判断是否有投票权限
      if (+this.substituteData.status === 1 && !this.substituteId) {
        this.$message.error(`会议发起人需要选择替代人`);
        return false;
      }
      if (!this.voteContent) {
        this.$message.error(`请选择Vote评价`);
        return false;
      } else {
        return true;
      }
    },
    vote() {
      if (this.validate()) {
        vote({
          voteId: this.voteId,
          substituteId: this.substituteId, //被代替者，如果是本人填写为空
          voteContent: this.voteContent, //0~4还是如何？
          voteReason: this.voteReason,
          additionalPoint: this.additionalPoint,
          voteRecordId: this.voteRecordId
        }).then(res => {
          if (res.code === 200) {
            this.$router.replace({
              path: `/project/voteRecords`,
              query: {
                voteId: this.voteId,
                projectId: this.$route.query.projectId
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.vote-page {
  height: 100vh;
  background: #fff;
  padding: 20px 60px;
  .top-bar {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding: 10px 0;
    .title {
      font-size: 18px;
      span {
        font-weight: bold;
        color: #000;
      }
    }
    .btn-group {
      .btn-item {
        height: 26px;
        width: 80px;
        margin-left: 10px;
      }
    }
  }
  .info-item {
    font-size: 14px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .item-label {
      min-width: 160px;
    }
    .item-content {
      position: relative;
      display: flex;
      align-items: center;
      max-width: 50%;
      .hint {
        position: absolute;
        bottom: -40px;
        font-size: 14px;
      }
    }
  }
  .info-item-textarea {
    .item-label {
      margin-right: 10px;
    }
    align-items: flex-start;
  }
  .common-info {
    position: relative;
    margin-top: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .vote-content {
    padding: 40px 0;
  }
  .vote-btn {
    margin: 50px auto;
    width: 100%;
    height: 40px;
    color: #fff;
    background: #1892f7;
  }
}
</style>
